var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOverflowActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#067BC2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4c1.101 0 2-.899 2-2s-.899-2-2-2-2 .899-2 2 .899 2 2 2zM2 11c1.101 0 2-.899 2-2s-.899-2-2-2-2 .899-2 2 .899 2 2 2zM2 18c1.101 0 2-.899 2-2s-.899-2-2-2-2 .899-2 2 .899 2 2 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverflowActive);
export default __webpack_public_path__ + "static/media/icon_overflow_active.c8d053c4799a3a6fab00f65073c939aa.svg";
export { ForwardRef as ReactComponent };